import { FulfillmentDistributionCenter } from 'common/types';
import { chain, sumBy } from 'lodash';

export function getDistributionRadius(
    distributionCenter: FulfillmentDistributionCenter
) {
    if (distributionCenter && distributionCenter.configuration) {
        const config = distributionCenter.configuration.filter(
            con => con.type === 'FULFILLMENT' && con.key === 'SHIPPING_RADIUS'
        );
        return config.length > 0 ? Number(config[0].value) : 0;
    }
    return 0;
}

export const isInStock = (
    distributionCenter: FulfillmentDistributionCenter,
    inventory: { id: number; qty?: number }[]
) => {
    if (distributionCenter.inventory && distributionCenter.inventory.length) {
        const _inventory = chain(inventory)
            .groupBy('id')
            .map((group, id) => ({ id, qty: sumBy(group, 'qty') }))
            .value();

        for (let i = 0; i < _inventory.length; i++) {
            if (
                !distributionCenter.inventory.some(
                    item =>
                        item.productId.toString() === _inventory[i].id &&
                        item.quantityAvailable >= _inventory[i].qty
                )
            )
                return false;
        }

        return true;
    }

    return false;
};

export const mapisPickupOrIsDelivery = (
    vendorDistributionCenters: FulfillmentDistributionCenter[]
) => {
    return vendorDistributionCenters.map(vdc => {
        const configuration = vdc?.configuration;
        if (configuration) {
            const isPickup = !!vdc.configuration.find(
                fulfillmentConfig =>
                    fulfillmentConfig.key === 'FULFILLMENT_TYPE_ID' &&
                    fulfillmentConfig.value === 'PICK_UP'
            );
            const isDelivery = !!vdc.configuration.find(
                fulfillmentConfig =>
                    fulfillmentConfig.key === 'FULFILLMENT_TYPE_ID' &&
                    fulfillmentConfig.value === 'DELIVERY'
            );

            const isPickupOnly = isPickup && !isDelivery;

            return {
                ...vdc,
                isPickup,
                isDelivery,
                isPickupOnly,
            };
        }
        return vdc;
    });
};

export const isPickupOrDeliveryMessage = (
    vdc: FulfillmentDistributionCenter
) => {
    if (vdc?.isDelivery && vdc?.isPickup) {
        return 'Pickup/Delivery';
    }
    if (vdc?.isPickup) {
        return 'Pickup Only';
    }
    if (vdc?.isDelivery) {
        return 'Delivery Only';
    }
    return '';
};
